import React from "react"
import PropTypes from "prop-types"
import "./Dropdown.css"
import { ArrowDownIcon } from "../../Icons"

class DropdownOption extends React.Component {
  handleClick = () => {
    const { onClick, value } = this.props
    onClick(value)
  }

  render() {
    const { label, className } = this.props
    return (
      <li onClick={this.handleClick} className={className}>
        {label}
      </li>
    )
  }
}

DropdownOption.propTypes = {
  onClick: PropTypes.func.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired //,
  // label: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired
}

class Dropdown extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      shown: false
    }
    this.ref = React.createRef()
  }

  handleClickOutside = e => {
    if (
      this.ref.current !== e.path[0] &&
      !this.ref.current.contains(e.path[0])
    ) {
      this.setState(state => ({
        ...state,
        shown: false
      }))
    }
  }

  handleClick = () => {
    this.setState({
      shown: !this.state.shown
    })
  }

  selectOption = option => {
    this.props.onSelect(option)
    this.setState({ shown: false })
  }

  getOptionLabel = () => {
    const selectedOption = this.props.options.find(
      option => option.value === this.props.value
    )
    const label =
      (selectedOption && selectedOption.label) || this.props.defaultValue.label
    return label
  }

  handleAction = () => {
    this.setState({
      shown: !this.state.shown
    })
    this.props.action && this.props.action.handler()
  }

  componentDidMount() {
    document.addEventListener("mousedown", this.handleClickOutside)
  }

  componentWillUnmount() {
    document.removeEventListener("mousedown", this.handleClickOutside)
  }

  render() {
    const winHeight = window.innerHeight
    const { bottom } =
      (this.ref.current && this.ref.current.getBoundingClientRect()) || 0
    return (
      <div
        className={`Dropdown ${this.state.shown ? "shown" : ""} ${(this.props
          .value.value !== "" &&
          "has-selected") ||
          ""} ${winHeight - bottom < 260 ? "up" : "down"}`}
        ref={this.ref}
      >
        <span onClick={this.handleClick}>
          {this.getOptionLabel()} <ArrowDownIcon />
        </span>
        {this.props.options &&
          this.props.options.length > 0 && (
            <div className="Dropdown-options">
              {this.props.action && (
                <button
                  className="Dropdown-options-action"
                  type="button"
                  onClick={this.handleAction}
                >
                  {this.props.action.label}
                </button>
              )}
              <ul>
                {this.props.options.map((option, i) => (
                  <DropdownOption
                    key={i}
                    onClick={this.selectOption}
                    value={option.value}
                    label={option.label}
                    className={(i === 0 && "first") || ""}
                  />
                ))}
              </ul>
            </div>
          )}
      </div>
    )
  }
}

Dropdown.propTypes = {
  options: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
        .isRequired
      // label: PropTypes.string.isRequired
    })
  ).isRequired,
  defaultValue: PropTypes.shape({
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired
    // label: PropTypes.string.isRequired
  }),
  onSelect: PropTypes.func,
  action: PropTypes.shape({
    handler: PropTypes.func
    // label: PropTypes.string
  })
}

export default Dropdown
